import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddComponentDialog } from '../dialogs/add-component.dialog';
import { EditEvent } from '../constants/edit.constants';

@Component({
    selector: 'add-component',
    template: `<div class="ed-AddComponent_Overlay" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()"
    dnd-droppable [dropZones]="['componentDropZone']" (onDropSuccess)="moveComponent($event)">
    <div class="row no-padding around-xs">
        <div class="col-xs-12" *ngIf="shouldDisplay">
            <hr class="ed-AddComponent_HorizontalRule">
            <button mat-mini-fab color="primary" (click)="openAddComponentDialog()" matTooltip="Add Component">
                <i class="fa fa-sm fa-plus"></i>
                <!-- Add App -->
            </button>
        </div>
    </div>
</div>`
})
export class AddComponentComponent {

    @Input() location: string;
    @Input() pageId: string;
    @Input() isColumn: boolean;
    @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();

    shouldDisplay: boolean = false;

    constructor( public dialog: MatDialog) {}

    mouseEnter() {
        this.shouldDisplay = true;
    }

    mouseLeave() {
        setTimeout(() => {
            this.shouldDisplay = false;
        }, 100);
    }

    openAddComponentDialog() {
        let dialogRef = this.dialog.open(AddComponentDialog, { panelClass : ['dlg-AddComponent', 'modal'],
                width: '500px',
                autoFocus: false,
                data: {
                    newLocation: this.location,
                    previousLocation: null,
                    component: null,
                    pageId: this.pageId,
                    isColumn: this.isColumn
                }
        });
        dialogRef.afterClosed().subscribe(data => {
          if (data) {
            // data = merge(data, this.componentMeta);
            window.dispatchEvent(new CustomEvent(EditEvent.ADD_COMPONENT, {
                detail: { data }
            }));
            this.onSelected.emit(data);
          }
        });
    }

    moveComponent(event: any) {
        if (event && event.dragData) {
            let eventData = event.dragData;
            let selector: string = eventData.componentTag;
            let previousLocation: string = eventData.location;
            let data = {
                newLocation: this.location,
                previousLocation: previousLocation,
                pageId: this.pageId,
                isColumn: this.isColumn,
                component: {
                    selector: selector
                }
            };
            window.dispatchEvent(new CustomEvent(EditEvent.RELOCATE_COMPONENT, {
                detail: { data }
            }));
        }
    }
}
